import axios from 'axios';

// Base URL points to PHP backend sitting side-by-side with CRA dev server or production build.
// You can override with REACT_APP_API_BASE env variable during build/deploy.
export const BASE_URL = 'https://dankula.x10.mx';
export const ENDPOINT = `${BASE_URL}/auth.php`;

// Small helper to attach auth header automatically after login
export const setAuthToken = (token) => {
  if (token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  } else {
    delete axios.defaults.headers.common['Authorization'];
  }
};

export const loginRequest = async (username, password) => {
  return axios.post(`${ENDPOINT}?action=login`, { username, password });
};

export const registerRequest = async (data) => {
  return axios.post(`${ENDPOINT}?action=register`, data);
};

export const resetPasswordRequest = async (email) => {
  return axios.post(`${ENDPOINT}?action=reset`, { email });
};
